import { useSnackbar } from 'notistack';
import useSWR from 'swr';
import { useContext } from 'react';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import { ScoringContext } from '@/contexts/scoring/context';
import { ApiError } from '../ApiError';
import { HTTP_STATUS_CODE } from '../constants';
import {
  SERVICE_ENDPOINT,
  fetchFromMTService,
} from '../fetcher/monitoringToolService';
import { EvaluationSourcesType } from '../types';

export const useEvaluationSources = () => {
  const { enqueueSnackbar } = useSnackbar();
  const token = useAuthToken();
  const {
    state: { fixtureSummary },
  } = useContext(ScoringContext);

  const { data, error, mutate } = useSWR<EvaluationSourcesType[], ApiError>(
    token && fixtureSummary?.collectionId
      ? {
          token,
          endpoint: SERVICE_ENDPOINT.EvaluationSources(
            fixtureSummary.collectionId,
          ).getAllSources.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (
          e.status !== HTTP_STATUS_CODE.NOT_FOUND &&
          e.status !== HTTP_STATUS_CODE.UNAUTHORIZED
        ) {
          return enqueueSnackbar(e.title, { variant: 'error' });
        }
        if (e.status === HTTP_STATUS_CODE.NOT_FOUND) return;
        if (e.status === HTTP_STATUS_CODE.UNAUTHORIZED) return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    evaluationSources: data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};
